import { useState } from "react";
import { toast } from "sonner";
import { PageHeader } from "@/components/layout/PageHeader";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useOrganizerProfile, useUpdateOrganizerProfile } from "@/hooks/useOrganizerProfile";

function ProfileForm({ initialName, initialUrl }: { initialName: string; initialUrl: string }) {
  const updateProfile = useUpdateOrganizerProfile();
  const [displayName, setDisplayName] = useState(initialName);
  const [displayUrl, setDisplayUrl] = useState(initialUrl);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await updateProfile.mutateAsync({ displayName, displayUrl });
      toast.success("Dane zaktualizowane");
    } catch (err) {
      toast.error("Nie udało się zapisać danych", {
        description: err instanceof Error ? err.message : undefined,
      });
    }
  };

  const hasChanges = displayName !== initialName || displayUrl !== initialUrl;

  return (
    <form onSubmit={handleSubmit} className="space-y-6 max-w-lg">
      <div className="space-y-2">
        <Label htmlFor="displayName">Nazwa wyświetlana</Label>
        <Input
          id="displayName"
          value={displayName}
          onChange={(e) => setDisplayName(e.target.value)}
          placeholder="np. Fundacja Kultura"
        />
        <p className="text-xs text-muted-foreground">
          Widoczna jako źródło wydarzenia dla użytkowników aplikacji.
        </p>
      </div>
      <div className="space-y-2">
        <Label htmlFor="displayUrl">Link do strony (opcjonalny)</Label>
        <Input
          id="displayUrl"
          value={displayUrl}
          onChange={(e) => setDisplayUrl(e.target.value)}
          placeholder="https://..."
        />
        <p className="text-xs text-muted-foreground">
          Link, do którego prowadzi wyświetlana nazwa źródła.
        </p>
      </div>
      <Button type="submit" disabled={!displayName || !hasChanges || updateProfile.isPending}>
        {updateProfile.isPending ? "Zapisywanie..." : "Zapisz"}
      </Button>
    </form>
  );
}

export default function OrganizerProfilePage() {
  const { data: profile, isLoading } = useOrganizerProfile();

  return (
    <div>
      <PageHeader title="Moje dane" />
      {isLoading || !profile ? (
        <div className="space-y-4 max-w-lg">
          <div className="h-10 rounded bg-white animate-pulse border border-black/5" />
          <div className="h-10 rounded bg-white animate-pulse border border-black/5" />
        </div>
      ) : (
        <ProfileForm
          key={profile.displayName + profile.displayUrl}
          initialName={profile.displayName}
          initialUrl={profile.displayUrl}
        />
      )}
    </div>
  );
}
